(function () {
    "use strict";

    angular
        .module("trakeyeApp")
        .controller("RouteTypeDialogController", RouteTypeDialogController);

    RouteTypeDialogController.$inject = [
        "$timeout",
        "$scope",
        "$stateParams",
        "$state",
        "entity",
        "RouteType",
        "User",
        "RouteTypeSearch",
        "AllCustomRouteTypeAttribute",
    ];

    
    function RouteTypeDialogController(
        $timeout,
        $scope,
        $stateParams,
        $state,
        entity,
        RouteType,
        User,
        RouteTypeSearch,
        AllCustomRouteTypeAttribute
    ) {
        var vm = this;
        //routetype attribute types
        $scope.attributetypes = ["INTEGER", "FLOAT", "STRING", "BOOLEAN"];
        //end
        vm.routeType = entity;
        vm.routeTypeImageName = routeTypeImageName;
        vm.decodeImage = decodeImage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.customRouteTypeAttributes = loadPage();
        vm.customAttributesMap = {};
        $scope.allimages = false;
        $scope.toggle = function () {
            $scope.allimages = !$scope.allimages;
        };
        vm.save = save;
        $(":file").filestyle({ buttonBefore: true });
        $(":file").filestyle("buttonText", "Browse File");

        

        vm.checkNumber;

        
        
       

        function routeTypeImageName(image) {
            vm.routeType.image = image;
        }
        
       
        function decodeImage(img) {
            return window.atob(img);
        }

        function loadPage() {
            AllCustomRouteTypeAttribute.getAll(function (response) {
                vm.customRouteTypeAttributes = response;
                response.forEach(function (arrayItem) {
                    vm.customAttributesMap[arrayItem.name] =
                        arrayItem.customRouteTypeAttributeValues;
                });
            });
        }

        //      vm.users = User.query();
        vm.items = [{ name: "", attributeDataType: {}, value: "" }];

        if (
            vm.routeType.routeTypeAttribute != null &&
            vm.routeType.routeTypeAttribute.length != 0
        ) {
            vm.items = vm.routeType.routeTypeAttribute;
        }
        var tempItems = [];
        vm.items.forEach(function (value) {
            if (value.routeCategory == null) {
                value.routeCategory = "DEFAULT";
            }
            tempItems.push(value);
        });

        vm.items = tempItems;
        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }
        function save() {
            vm.isSaving = true;
            if (vm.routeType.id !== null) {
                vm.routeType.routeTypeAttribute = [];
                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.routeType.routeTypeAttribute.push({
                        routeCategory: vm.items[i].routeCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        routeTypeAttribOrder: vm.items[i].routeTypeAttribOrder
                    });
                }
                RouteType.update(vm.routeType, onSaveSuccess, onSaveError);
            } else {
                vm.routeType.routeTypeAttribute = [];

                for (var i = 0; i < vm.items.length; i++) {
                    var attributes = { name: vm.items[i] };
                    vm.routeType.routeTypeAttribute.push({
                        routeCategory: vm.items[i].routeCategory,
                        id: vm.items[i].id,
                        mandatory: vm.items[i].mandatory,
                        name: vm.items[i].name,
                        attributeDataType: vm.items[i].attributeDataType,
                        value: vm.items[i].value,
                        routeTypeAttribOrder: vm.items[i].routeTypeAttribOrder
                    });
                }
                RouteType.save(vm.routeType, onSaveSuccess, onSaveError);
            }
        }

        $("#routeTypeImage").change(function () {
            var filesSelected = document.getElementById("routeTypeImage").files;
            for (var i = 0; i < filesSelected.length; i++) {
                var fileReader = new FileReader();
                fileReader.onload = function (fileLoadedEvent) {
                    var test = window.btoa(fileLoadedEvent.target.result);
                    vm.routeType.image = test;
                };
                fileReader.readAsBinaryString(filesSelected[i]);
            }
        });

        function onSaveSuccess(result) {
            $scope.$emit("trakeyeApp:routeTypeUpdate", result);
            vm.isSaving = false;

            var pageValue = sessionStorage.getItem("prevPage");
            $state.go("route-type");
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        vm.addmore = function (index) {

            
            //vm.items.push({name: '',attributeDataType:{}, value:''});
            vm.items.splice((index+1), 0, {
                name: "",
                attributeDataType: {},
                value: "",
            });
           
        };

        vm.remove = function (index) {
            vm.items.splice(index, 1);
           
           
        };

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

       
    }
})();
